// extracted by mini-css-extract-plugin
export default {"contentBox":"index_contentBox_tFc-h","content":"index_content_NbNek"};